@if (myMarkets$ | async; as myMarkets) {
  @if (myMarkets?.length === 0 && !(loading$ | async) && !isFetchingStatus()) {
    <app-status-alert
      [config]="{
        title: 'No Markets Added.',
        subtitle: 'Add markets here.',
        type: 'info',
        mode: 'block',
        icon: 'dynamic_feed'
      }" />
  }

  @if (myMarkets?.length) {
    <mat-accordion multi="true">
      @for (market of myMarkets; track marketOps.marketTracker(market)) {
        @let descPref = market?.descriptionPrefix;
        @let isBookmaker = descPref === "Bookmaker";
        @let isFancy = descPref === "Fancy";
        @if (isBookmaker) {
          <app-bookmaker [market]="market" />
        } @else if (isFancy) {
          <app-fancy-market [market]="market" />
        } @else {
          <app-market [data]="market" headerType="my-markets" />
        }
      }
    </mat-accordion>
  }
}
